import { render, staticRenderFns } from "./Mix.vue?vue&type=template&id=68488310&scoped=true"
import script from "./Mix.vue?vue&type=script&lang=js"
export * from "./Mix.vue?vue&type=script&lang=js"
import style0 from "./Mix.vue?vue&type=style&index=0&id=68488310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68488310",
  null
  
)

export default component.exports